import { render, staticRenderFns } from "./MyCSSPickerDlg.vue?vue&type=template&id=68d5f2fb&scoped=true&"
import script from "./MyCSSPickerDlg.vue?vue&type=script&lang=js&"
export * from "./MyCSSPickerDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d5f2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d5f2fb')) {
      api.createRecord('68d5f2fb', component.options)
    } else {
      api.reload('68d5f2fb', component.options)
    }
    module.hot.accept("./MyCSSPickerDlg.vue?vue&type=template&id=68d5f2fb&scoped=true&", function () {
      api.rerender('68d5f2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyCSSPickerDlg.vue"
export default component.exports